import { render, staticRenderFns } from "./ProductConsumption.vue?vue&type=template&id=1221fef5&"
import script from "./ProductConsumption.vue?vue&type=script&lang=js&"
export * from "./ProductConsumption.vue?vue&type=script&lang=js&"
import style0 from "./ProductConsumption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports